module.exports = __webpack_public_path__ + "d069616cbc4fb181cdadc171a5038ff2.svg";